import { Location } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { UserRoles } from "src/app/models/enums/user-roles";
import { CommonService } from "src/app/services/common/common.service";
import { FileUploadTaskService } from "src/app/services/file-upload-task/file-upload-task.service";
import { UserService } from "src/app/services/user.service";
import { ActionPerform, Attachment, AttachmentDTO, CommentDto, FileParameter, FileUploadTaskDto } from "src/app/web-api-client";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { CommentService } from "src/app/services/comment.service";
import { Subscription } from "rxjs";
import { DocumentService } from "src/app/services/document.service";
import { AddCommentDto } from "src/app/models/AddCommentDto";
import { CommentType } from "src/app/models/enums/CommentType";
import { NotificationFrequency } from "src/app/models/enums/NotificaionFrequency";
import { NotificationType } from "src/app/models/enums/NotificationType";
import { UserAction } from "../../../../models/enums/user-actions";

@Component({
  selector: "app-file-upload-task-detail",
  templateUrl: "./file-upload-task-detail.component.html",
  styleUrls: ["./file-upload-task-detail.component.scss"],
})
export class FileUploadTaskDetailComponent implements OnInit {

  dateTime = new Date()
  taskId: string;
  task: FileUploadTaskDto;
  commentAttachments: AttachmentDTO[] = [];
  gfg = false;
  uploadedFiles: File[] = [];
  statusText = "";
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp
  faTrash = faTrash;
  isNetworkMember: boolean;
  isCollaborator: boolean;
  savingLoader = false;
  loadingTask: boolean = false;
  displayTaskAction: boolean = false;
  comments: CommentDto[] = [];

  deletedCommentEventSubscription: Subscription;
  commentAttachmentAddedEventSubscription: Subscription;

  @Input() isMarkAsHandleApplicable: boolean = false;

  constructor(
    private activatedroute: ActivatedRoute,
    public fileUploadTaskService: FileUploadTaskService,
    private sanitizer: DomSanitizer,
    public location: Location,
    private userService: UserService,
    public commonService: CommonService,
    private commentService: CommentService
  ) { }

  // oninit method
  async ngOnInit() {
    this.loadingTask = true;

    this.taskId = this.activatedroute.snapshot.paramMap.get('id');
    this.isNetworkMember = await this.userService.isUserInRole(UserRoles.NetworkMember);
    this.isCollaborator = await this.userService.isUserInRole(UserRoles.Collaborator);
    
    this.task = this.fileUploadTaskService.activeFileUploadTask;
    this.comments = this.commentService.discussion?.comments?.filter(x => x.isDeleted == false);
    this.commentAttachments = this.getCommentAttachments(this.comments);

    //Log task access
    this.commonService.logUserAction(UserAction.NavigateToTask, this.taskId, this.task.processId);

    this.statusText = this.commonService.getTaskStatusByNumber(this.task.status.value);
    this.displayTaskAction = await this.commonService.displayTaskAction(this.task);

    this.deletedCommentEventSubscription = this.commentService.deleteCommentEvent.subscribe((commentId) => { this.filterOutDeletedAttachments(commentId) });
    this.commentAttachmentAddedEventSubscription = this.commentService.addCommentAttachmentEvent.subscribe((attachment) => { this.updateAttachmentsList(attachment) });

    this.loadingTask = false;
  }

  // when the file is uploaded
  fileUploaded(response: {
    isUploaded: boolean;
    message: string;
    files?: File[];
  }) {
    // if files where uploaded
    if (response.isUploaded) {
      // loop through the files
      for (let i = 0; i < response.files.length; i++) {
        // add the file to the list
        this.uploadedFiles.push(response.files[i]);
      }
    }
  }

  // method to remove a file
  removeFile(index: number) {
    // remove the file
    this.uploadedFiles.splice(index, 1);
  }

  // method to save the changes
  async save() {    
    // saving started
    this.savingLoader = true;
    // loop through the files
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      const filePath = await this.fileUploadTaskService.uploadFileToTask(
        this.task,
        this.uploadedFiles[i],
        i === this.uploadedFiles.length - 1 ? true : false
      );
      const attachment = new Attachment();
      attachment.name = this.uploadedFiles[i].name;
      attachment.path = filePath;
      this.task.attachments.push(attachment);
    }
    // empty the selection
    this.uploadedFiles = [];
    this.ngOnInit();

    // saving finished
    this.savingLoader = false;
  }

  // sanitize the url to download the files
  sanitize(url: string) {
    // return safe url
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getCommentAttachments(comments: CommentDto[]) {
    var attachments = comments.map(x => x.attachments).flat();
    var sortedAttachemnts = attachments?.sort((a, b) => a.fileDate > b.fileDate ? -1 : 1);
    return sortedAttachemnts;
  }

  filterOutDeletedAttachments(commentId: string) {
    var filteredComments = this.comments.filter(x => x.id != commentId);
    var attachments = this.getCommentAttachments(filteredComments);
    this.commentAttachments = attachments;
  }

  updateAttachmentsList(attachment: AttachmentDTO[]) {
    this.commentAttachments.push(...attachment);
  }

  ngOnDestroy() {
    this.deletedCommentEventSubscription.unsubscribe();
    this.commentAttachmentAddedEventSubscription.unsubscribe();
  }

  getButtonName() {
    if (this.isNetworkMember) {
      return "Mark as Handled";
    }
  
    else if (this.isCollaborator) {
      return "Mark as Not Handled";
    }

  }

  shouldBeDisabled(): boolean {
    if (this.isNetworkMember) {
      return this.task?.actionPerform == ActionPerform.MarkAsDone;

    }
  
    if (this.isCollaborator) {
      return this.task?.actionPerform == ActionPerform.MarkAsNotDone || this.task?.actionPerform == null;
    }
  }

  excutedByNetworkMember(){
    this.commonService.treatedByNetworkMember(this.task, this.fileUploadTaskService);
  }
    
}
